export enum ChangePasswordErrors {
    CurrentPasswordEmpty = 'current_password_empty',
    NewPasswordEmpty = 'new_password_empty',
    ConfirmPasswordEmpty = 'confirm_password_empty',
    PasswordsNotMatching = 'passwords_not_matching',
    CurrentPasswordNotValid = 'current_password_not_valid',
    OldAndNewPasswordMatching = 'old_and_new_passwords_matching',
    BruteForce = 'bruteforce',
}